/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UMSCustomPortionRequestResponse
 */
export interface UMSCustomPortionRequestResponse {
    /**
     * 
     * @type {string}
     * @memberof UMSCustomPortionRequestResponse
     */
    'status'?: UMSCustomPortionRequestResponseStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof UMSCustomPortionRequestResponse
     */
    'calories'?: number;
    /**
     * 
     * @type {number}
     * @memberof UMSCustomPortionRequestResponse
     */
    'protein'?: number;
    /**
     * 
     * @type {number}
     * @memberof UMSCustomPortionRequestResponse
     */
    'carbs'?: number;
    /**
     * 
     * @type {number}
     * @memberof UMSCustomPortionRequestResponse
     */
    'fat'?: number;
}

export const UMSCustomPortionRequestResponseStatusEnum = {
    Pending: 'PENDING',
    Approved: 'APPROVED',
    Adjusted: 'ADJUSTED',
    Rejected: 'REJECTED',
    Cancelled: 'CANCELLED'
} as const;

export type UMSCustomPortionRequestResponseStatusEnum = typeof UMSCustomPortionRequestResponseStatusEnum[keyof typeof UMSCustomPortionRequestResponseStatusEnum];


